export enum ResidentialSituationDuration {
  LessThanOneMonth = '< 1 mois',
  BetweenOneAndThreeMonths = '1-3 mois',
  BetweenFourAndSixMonths = '4-6 mois',
  MoreThanSixMonths = '> 6 mois',
}
